/*=====================================
    SignInDialog

    Author: Ac
    CreateTime: 2018 / 08 / 17
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle, Colors, DialogStyle } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import Recaptcha from "react-grecaptcha";
import GLOBAL from 'nonnglobal';

/*--------------------------
    Styled
--------------------------*/
const Title = styled.div`
    font-size: 23px;
    color: #4A4A4A;
    font-weight: 600;
    text-align: center;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #D9D9D9;
`;
const RowTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #232423;
    margin-bottom: 10px;
`;
const Input = GlobalStyle.BasicInput.extend`
    margin-bottom: 16px;
`;
const ForgetPassword = styled.div`
    font-size: 13px;
    color: #9B9B9B;
    text-decoration: underline;
    cursor: pointer;
`;
const ActionBtn = styled.div`
    position: relative;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 2px;
    background-color: ${Colors.MAIN_COLOR};
    color: #FFF;
    font-size: 16px;
    margin: 17px 0 16px;
    cursor: pointer;
    opacity: ${({ disable }) => disable ? 0.5 : 1};
`;
const LoadingWrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 20px;
`;
const Hint = styled.div`
    text-align: center;
    font-size: 14px;
    color: #4A4A4A;
`;
const SignUpText = styled.span`
    color: ${Colors.MAIN_COLOR};
    cursor: pointer;
`;
/*--------------------------
    Main Component
--------------------------*/
class SignInDialog extends Component {

    // static propTypes = {
    // };

    constructor(props) {

        super(props);

        this.hideDialog = this.hideDialog.bind(this);
        this.onTextChangeHandler = this.onTextChange.bind(this);
        this.onAccountTextChangeHandler = this.onTextChangeHandler.bind(this, 'memberId');
        this.onPasswordTextChangeHandler = this.onTextChangeHandler.bind(this, 'password');
        this.recaptchaVerifyCallback = this.recaptchaVerifyCallback.bind(this);
        this.recaptchaExpiredCallback = this.recaptchaExpiredCallback.bind(this);
        this.login = this.login.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.state = {
            memberId: '',
            password: '',
            recaptchaResponse: null,
            isNeedToCheckIdNumber: false,
            idNumber: '',
        };

    }

    componentDidMount (){
        window.addEventListener('keydown', this.onKeydown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown({ keyCode }) {
        if(keyCode === 27)
            this.hideDialog();
    }

    hideDialog (){
        this.props.webActions.hideSignInDialog();
    }

    onTextChange (stateName, event){

        const val = event.target.value;

        if(this.state[stateName] === val){
            return;
        }

        this.setState({
            [stateName]: val,
        });
    }

    recaptchaVerifyCallback (response) {
        this.setState({
            recaptchaResponse: response,
        });
    }

    recaptchaExpiredCallback (){
        this.props.webActions.openAlertDialog({
            title: '安全認證已過期',
        });
    }

    login() {

        const{
            memberId,
            password,
            recaptchaResponse,
            isLoading,
        } = this.state;

        if(isLoading) {
            return;
        }

        if(GLOBAL.isEmpty(memberId) || GLOBAL.isEmpty(password)){
            this.props.webActions.openAlertDialog({
                title: '錯誤訊息',
                description : '請輸入帳號或密碼',
                closeName: '確定',
                closeCallback: () => {
                }
            });
            return;
        }
        if(GLOBAL.isEmpty(recaptchaResponse)){
            this.props.webActions.openAlertDialog({
                title: '錯誤訊息',
                description : '請勾選『我不是機器人』',
                closeName: '確定',
                closeCallback: () => {

                }
            });
            return;
        }

        this.setState({
            isLoading: true,
        }, () => {
            this.props.memberActions.login({
                memberid: memberId,
                passwd: password,
                passcode: recaptchaResponse,
            }).then(() => {
                this.hideDialog();
            }, error =>{

                this.setState({
                    isLoading: false,
                    recaptchaResponse: '',
                }, () => {

                    window.grecaptcha.reset();
                    
                    let errorMsg = '系統發生無法預期的錯誤';

                    if(error && error.code) {
                        switch(error.code) {
                            case 'error.onemonthNoLoginError':
                                this.setState({
                                    isNeedToCheckIdNumber: true,
                                });
                                return;
                            case 'error.account.accountNotExist':
                                errorMsg = "此帳號不存在";
                                break;
                            case 'error.account.isFreeze':
                                return this.props.webActions.openAlertDialog({
                                    title: '錯誤訊息',
                                    renderDescription: closeDialog => (
                                        <React.Fragment>
                                            <span>會員停權中，請洽客服人員。</span><br/>
                                            <CupoySrefView
                                                statename={CupoyRouter.STATES.NEWS_CONTENT}
                                                params={{
                                                    id: '1590395459418',
                                                }}
                                                onClick={() => {
                                                    closeDialog();
                                                    this.hideDialog();
                                                }}
                                            >
                                                查看停權原因！
                                            </CupoySrefView>
                                        </React.Fragment>
                                    ),
                                    closeName: '確定',
                                });
                            case 'error.formValidator.passwordFailed':
                                errorMsg = "密碼錯誤，請重新操作。";
                                break;
                            case 'error.formValidator.antiPassCodeFailed':
                                errorMsg = "安全性驗證錯誤";
                                break;
                            default:
                                errorMsg = error.message;
                                break;
                        }
                    }

                    this.props.webActions.openAlertDialog({
                        title: '錯誤訊息',
                        description : errorMsg,
                        closeName: '確定',
                    });
                });
            });
        })
    }

    openForgetPwdDialog = () => {
        this.hideDialog();
        this.props.webActions.openForgetPwdDialog();
    }

    openForgotAccountDialog = () => {
        this.hideDialog();
        this.props.webActions.openForgotAccountDialog();
    }

    handleIdNumber = event => {
        this.setState({
            idNumber: event.target.value,
        });
    }

    loginAndCheckId = () => {

        const {
            memberId,
            password,
            idNumber,
            isLoading,
        } = this.state;

        if(isLoading) {
            return;
        }

        const {
            result: chkResult,
            message: chkResultMsg,
        } = GLOBAL.chkIdnumber(idNumber);

        if (!chkResult) {
            this.props.webActions.openAlertDialog({
                title: '錯誤訊息',
                description : chkResultMsg,
                closeName: '確定',
            });
            return;
        }

        this.setState({
            isLoading: true,
        }, () => {
            this.props.memberActions.loginAndCheckId({
                memberId,
                password,
                idNumber,
            }).then(() => {
                this.hideDialog();
            }).catch(error => {

                this.setState({
                    isLoading: false,
                });

                this.props.webActions.openAlertDialog({
                    title: '錯誤訊息',
                    description : error && error.message
                        ? error.message
                        : '系統發生無法預期的錯誤，請聯絡客服人員或稍後再試',
                    closeName: '確定',
                });
            });
        });
    }

    render() {

        let {
            memberId,
            password,
            isLoading,
            isNeedToCheckIdNumber,
            idNumber,
        } = this.state;

        return (
            <DialogStyle.Content
                // style props
                maxWidth="350px"
                margin="90px auto auto auto"
                padding="40px"
                borderRadius="3px"
                // dialog props
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                closable={false}
                className="signup-modal"
                onClose={this.hideDialog}
            >
                <DialogStyle.CloseButton onClick={this.hideDialog}>
                    <i className="zmdi zmdi-close"></i>
                </DialogStyle.CloseButton>
                <Title>9199 會員登入</Title>

                {isNeedToCheckIdNumber
                    ? (
                        <React.Fragment>
                            <RowTitle>
                                身分證字號
                            </RowTitle>
                            <Input
                                type='text'
                                placeholder='請輸入身分證字號'
                                value={idNumber}
                                onChange={this.handleIdNumber}
                            />
                            <Hint>
                                您的帳號超過一個月未登入，為了您的帳號安全，請輸入您的身分證字號進行驗證！
                            </Hint>
                            <ActionBtn
                                onClick={this.loginAndCheckId}
                                disable={isLoading}
                            >
                                {isLoading && (
                                    <LoadingWrapper>
                                        <GlobalStyle.Spin color='#FFF' />
                                    </LoadingWrapper>
                                )}
                                送出
                            </ActionBtn>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <RowTitle>
                                帳號
                                <ForgetPassword onClick={this.openForgotAccountDialog}>忘記帳號？</ForgetPassword>
                            </RowTitle>
                            <Input
                                type='text'
                                placeholder='請輸入帳號'
                                value={memberId}
                                onChange={this.onAccountTextChangeHandler}
                            />
                            <RowTitle>
                                密碼
                                <ForgetPassword onClick={this.openForgetPwdDialog}>忘記密碼？</ForgetPassword>
                            </RowTitle>
                            <Input
                                type='password'
                                placeholder='請輸入密碼'
                                value={password}
                                onChange={this.onPasswordTextChangeHandler}
                            />
                            <RowTitle>安全性驗證</RowTitle>
                            <Recaptcha
                                sitekey={GLOBAL.grecaptcha_key}
                                callback={this.recaptchaVerifyCallback}
                                expiredCallback={this.recaptchaExpiredCallback}
                                locale="zh-TW"
                                className="g-recaptcha"
                                style={{
                                    transform: 'scale(0.9)',
                                    WebkitTransform: 'scale(0.9)',
                                    transformOrigin: '0 0',
                                    WebkitTransformOrigin: '0 0',
                                }}
                            />
                            <ActionBtn
                                onClick={this.login}
                                disable={isLoading}
                            >
                                {isLoading && (
                                    <LoadingWrapper>
                                        <GlobalStyle.Spin color='#FFF' />
                                    </LoadingWrapper>
                                )}
                                登入
                            </ActionBtn>
                            <Hint>
                                還不是會員嗎？
                                <CupoySrefView
                                    statename={CupoyRouter.STATES.REGISTER}
                                    stylecomponent={SignUpText}
                                    onClick={this.hideDialog}
                                >
                                    立即註冊
                                </CupoySrefView>
                            </Hint>
                        </React.Fragment>
                    )
                }
            </DialogStyle.Content>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(SignInDialog);